import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrintService } from 'src/app/core/services/print.service';
import { Invoice } from 'src/app/shared/models/financials/invoice';
import { TimesheetEntry, TimesheetExpense } from 'src/app/shared/models/timesheet/timesheetEntry';

@Component({
  selector: 'app-print-invoice-summary',
  templateUrl: './print-invoice-summary.component.html',
  styleUrls: ['./print-invoice-summary.component.scss']
})
export class PrintInvoiceSummaryComponent implements OnInit {

  @Input() invoice: Invoice;
  @Output() back: EventEmitter<any> = new EventEmitter<any>();
  @Output() issue: EventEmitter<any> = new EventEmitter<any>();

  entries: TimesheetEntry[] | null = null;

  expensesGroups: { disbursements: TimesheetExpense[], thirdPartyFees: TimesheetExpense[], thirdPartyDisbursements: TimesheetExpense[] };

  VAT = 0;
  totalPayableToWords: string;

  constructor(
    private printService: PrintService,
  ) {
    this.invoice = this.printService.data.invoice;
    this.entries = this.printService.data.entries;
    this.expensesGroups = this.printService.data.expensesGroups;

  }

  ngOnInit(): void {
    this.printService.onDataReady('invoice');
  }



}
